import type { CustomerId } from './types';

export const FEATURE_FLAGS = {
  BRF_REPORTS: 'BRF_REPORTS',
  DISCONNECT_PAYMENT: 'DISCONNECT_PAYMENT',
  GLOBAL_ERROR_MESSAGE: 'GLOBAL_ERROR_MESSAGE',
  CHRISTMAS_MODE: 'CHRISTMAS_MODE',
  MARKET_NEW_OBJECT_TYPES: 'MARKET_NEW_OBJECT_TYPES',
  CHAT_WIDGET: 'CHAT_WIDGET',
  MICROSOFT_BOOKINGS: 'MICROSOFT_BOOKINGS',
  CHAT_MESSAGE_OVERRIDE: 'CHAT_MESSAGE_OVERRIDE',
  HUBSPOT_CHAT: 'HUBSPOT_CHAT',
  GDPR: 'GDPR',
  DATAWAREHOUSE: 'DATAWAREHOUSE',
  DATAWAREHOUSE_INVOICES: 'DATAWAREHOUSE_INVOICES',
  GLOBAL_SEARCH_V2: 'GLOBAL_SEARCH_V2',
  CANCELLATION_FLOW_V2: 'CANCELLATION_FLOW_V2',
} as const;

export const LEVELS = ['prod', 'dev', 'local'] as const;

export const FEATURE_FLAG_CUSTOMER_IDS = {
  // Pigello
  CX_DEMO: 'ce9f9d02-19f3-49a7-b322-4a996b421ebe',
  BATALJONEN_DEMO: '766b56fe-1b83-43ce-b3d7-bc6bd64a238c',
  PIGELLO_DEMO_PROD: 'd5d75111-4de1-480b-91dd-5e865285a8cf',
  LINDA_DEMO: 'a991cd31-5a2c-44d4-9047-78ffc04bcc7e',
  // Stena
  STENA_DEMO: '540581d9-b884-491d-8ce6-ed8b42c9f8f9',
  STENA_VIDEO_DEMO: '6b93ed74-8645-40f8-9583-c36bd5d2e127',
  STENA_EDUCATION_PROD: 'f3f1c36f-2eb6-4974-8df9-97abe3f27b6f',
  STENA_PROD: 'ccc58b43-89c3-497d-95d8-58c027f2b047',
  // UppsalaHem
  UPPSALA_DEMO: '1f7322ad-9635-4b99-90e4-ac3aa2483d1f',
  UPPSALA_TEST_DEMO: 'cd87e27f-c7e3-4988-923d-05f8cf384370',
  UPPSALA_PROD: '881a65de-22c3-4ce2-b2a9-6a3899346313',
  UPPSALA_TEST_2_DEMO: 'b4dc91e8-4713-40c3-93aa-02631639f7b4',
  // Lennart Ericsson
  LENNART_ERICSSON_PROD: '7bdee539-4c0b-4050-bb79-a3d62bb4eaa2',
  // Hylte
  HYLTE_PROD: '640f3af7-3fce-4b51-a43c-11b1743bda7e',
  // Easy Depot
  EASY_DEPOT_PROD: '913ed18e-edaf-40f4-b8fe-d3ce41906100',
  // Aspelin Ramm
  ASPELIN_RAMM_PROD: '5f0c7b67-9a1c-4f5e-9a88-46c29e2bcafd',
  // Sweax
  SWEAX_PROD: '16fa2cc6-64e3-44a8-82cd-f4feba18ee51',
  // Obos
  OBOS_PROD: '6c37c36f-f19d-4f79-9a7b-e0f4d0ba56e1',
  // Hemmavid
  HEMMAVID_SVERIGE_PROD: 'dae23267-69ae-491c-bd3f-3970bce4dfa3',
  HEMMAVID_PROD: '5cb484b8-da18-45fd-925e-3a9a779ec458',
  // Ronnebyhus
  RONNEBYHUS_DEMO: '49e372b8-4354-41e0-a4f7-394e07380459',
  // Karlsborgbostäder
  KARLSBORG_PROD: 'a010f2e5-c418-4745-ae93-0214763bb0e9',
  // Sveaviken
  SVEAVIKEN_TEST_PROD: '3d5f0cee-b2c0-4101-b55a-de190a90dd12',
  SVEAVIKEN_SKARP_PROD: '2d5f0cee-b2c0-4101-b55a-de190a90dd12',
  // Trossö
  TROSSO_PROD: 'd021b5a1-fea8-4656-98e7-2181300ad5e0',
  // Fortis Fastigheter
  FORTIS_FASTIGHETER_PROD: 'a2fdf7f5-604a-4fca-a8ac-2b08c12e1797',
  // Klövern
  KLOVERN_PROD: '03063415-1a23-4578-8e42-c5f5ba82f6e7',
  // Vasaparken
  VASAPARKEN_PROD: '55a8bcf6-9e7f-4434-8a68-449b6bd5178c',
} as const satisfies Record<CustomerId, string>;
